import $ from 'jquery';

$(document).ready(function () {
  var timeout,
    downloadExport = $('#download-export');
  if (downloadExport.length) {
    timeout = parseInt(downloadExport.data('timeout'), 10) * 1000;
    window.setTimeout(function () {
      downloadExport.hide();
      $('#regenerate-export').show();
    }, timeout);
  }

  $('.js-export-type').change(function () {
    if (this.value == 'created_at') {
      $('.js-export-by-response').addClass('hidden');
      $('.js-export-by-created').removeClass('hidden');
    } else {
      $('.js-export-by-created').addClass('hidden');
      $('.js-export-by-response').removeClass('hidden');
    }
  });
});
